const cookieTableStructure = {
    caption: 'Related Cookies',
    headers: {
        name: 'Name',
        description: 'Purpose',
        duration: 'Duration',
    },
};

const en = {
    consentModal: {
        label: 'Information regarding your privacy on this website',
        title: 'Your privacy',
        description: `
            <p>Your privacy is important to us, therefore we don't collect any personal data without your consent. You can consent or reject the usage of external services for embedded media and visitors statistics here, or choose custom settings.</p>
            {{revisionMessage}}`,
        acceptAllBtn: 'Accept all',
        acceptNecessaryBtn: 'Only required',
        showPreferencesBtn: 'Custom settings',
        // closeIconLabel: 'Reject all and close',
        revisionMessage:
            '<p>We have made changes to the available options. Please review your settings.</p>',
        footer: `
            <a href="/privacy-policy">Privacy policy</a>
            <a href="/legal">Legal notes</a>
        `,
    },
    preferencesModal: {
        title: 'Privacy settings',
        acceptAllBtn: 'Accept all',
        acceptNecessaryBtn: 'Only required',
        savePreferencesBtn: 'Save custom settings',
        closeIconLabel: 'Close preferences',
        // serviceCounterLabel: 'Service|Services',
        sections: [
            {
                description:
                    'You can configure which cookies and external services we may use. Personal data may be transferred to external services with your consent. Learn more in our <a href="/privacy-policy" class="cc__link">privacy policy</a>.',
            },
            {
                title: 'Always required',
                description:
                    'The cookies listed here are always required to save your privacy settings and prevent forged form submissions.',
                linkedCategory: 'necessary',
                cookieTable: {
                    ...cookieTableStructure,
                    body: [
                        {
                            name: 'privacy_preferences',
                            description: 'Saves your privacy preferences',
                            duration: '365 days',
                        },
                        {
                            name: 'CRAFT_CSRF_TOKEN',
                            description: 'Prevents forged form submissions',
                            duration: 'Session',
                        },
                    ],
                },
            },
            {
                title: 'Statistics',
                description: 'We use Google Tag Manager, Google Analytics and Google Ads to collect and analyze visitor behavior in order to continuously improve our offer. In addition, we measure the effectiveness of our advertising campaigns. If you consent to the use of these statistics tools, personal data such as your IP address will be transferred to Google and processed there.',
                linkedCategory: 'analytics',
                cookieTable: {
                    ...cookieTableStructure,
                    body: [
                        {
                            name: '_ga',
                            description: 'Registers a unique ID that is used to generate statistical data on how the visitor uses the website.',
                            duration: '2 years',
                        },
                        {
                            name: '_ga_#',
                            description: 'Collects data on how many times a user has visited a website as well as data for the first and last visit. Used by Google Analytics.',
                            duration: '2 years',
                        },
                        {
                            name: '_gcl_au',
                            description: 'Used to track and store conversions across the site.',
                            duration: 'Persistent',
                        },
                        {
                            name: 'IDE',
                            description: 'Used by Google DoubleClick to register and report the website user\'s actions after viewing or clicking one of the advertiser\'s ads with the purpose of measuring the efficacy of an ad and to present targeted ads to the user.',
                            duration: '1 year',
                        },
                    ],
                },
            },
            {
                title: 'External media',
                description:
                    'This category activates embedded media from external services. The listed services may collect personal data when active.',
                linkedCategory: 'media',
                cookieTable: {
                    ...cookieTableStructure,
                    body: [
                        {
                            name: 'im_youtube',
                            description: 'Stores consent for embedded YouTube-Videos',
                            duration: '365 days',
                        },
                        {
                            name: 'im_vimeo',
                            description: 'Stores consent for embedded Vimeo-Videos',
                            duration: '365 days',
                        },
                        {
                            name: '__cf_bm',
                            description: 'Used to differentiate real users from bots.',
                            duration: '30 minutes',
                        },
                    ],
                },
            },
        ],
    },
};

export { en };
